import { ActionType } from 'typesafe-actions';
import { createDataFetchActions } from '../dataFetching/generators';
import { VALUE_PROPS_IDENTIFIER } from './types';

export const fetchValuePropsData = createDataFetchActions(
    '@VALUE_PROPS_IDENTIFIER',
    ({ apiService }) => () => apiService.shopApi.getValuePropositions(),
    () => VALUE_PROPS_IDENTIFIER
);

export const ValuePropsActions = fetchValuePropsData.actions;

export type ValuePropsActionTypes = ActionType<typeof ValuePropsActions>;
export const getValuePropsActionsIfNeeded = fetchValuePropsData.thunk;
